// extracted by mini-css-extract-plugin
export default {"headerAction":"TableHeaderActions_headerAction__g1gvP","refetchWrapper":"TableHeaderActions_refetchWrapper__T57tW"};